import { render, staticRenderFns } from "./FunctionBoxActivation.vue?vue&type=template&id=51b228fe&"
import script from "./FunctionBoxActivation.vue?vue&type=script&lang=js&"
export * from "./FunctionBoxActivation.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports